// status.uptrack.app is the same app as uptrack.app. Its root URL shows Uptrack's own status page
// (see the rewrite in router.tsx). Any other marketing page on that host is a duplicate of the page on
// uptrack.app: Semrush (2026-11-03) showed pages such as status.uptrack.app/tools/is-website-down/twitch.tv
// ranking in place of the uptrack.app URL. Those requests get a permanent redirect to the main site.

export const STATUS_HOST = 'status.uptrack.app'
export const MAIN_ORIGIN = 'https://uptrack.app'

/**
 * The uptrack.app URL for a marketing page requested on the status host, or `null` when the request
 * needs no redirect (another host, or no host known).
 *
 * Only pages inside the `_site` layout call this, so every path that reaches it on the status host is a
 * marketing page. The status page itself (`/` and `/status/*`) and assets do not use the `_site` layout.
 */
export function mainSiteUrlForStatusHost(host: string | null | undefined, pathname: string, search = ''): string | null {
  const name = (host ?? '').split(':')[0].toLowerCase()
  if (name !== STATUS_HOST) return null
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`
  const query = search && !search.startsWith('?') ? `?${search}` : search
  return `${MAIN_ORIGIN}${path}${query}`
}
